import React, { useEffect } from 'react'
import { useFormState, useFormApi } from 'informed'
import { Row, Col } from 'react-flexbox-grid'
import ContentBlock, { ExpandableBlocks } from 'components/ContentBlock'
import { Text, Select, Checkbox } from 'components/forms'
import { loadAppConstants } from 'gql/query'
import Divider from 'components/Divider'
import { useTranslation } from 'react-i18next'
import useLocale from 'hooks/useLocale'

const EftTerminal = ({ creditButtons = [] }) => {
	const locales = useLocale()
	const formState = useFormState()
	const formApi = useFormApi()
	const terminalType = formState?.values?.parameters?.paymentTerminal?.id || -1
	const [t, i18n] = useTranslation()
	const displayDefaultFields = !['7', '8', '9', '-1', '10', '12'].includes(terminalType)
	const selectOptions = creditButtons.reduce((acc, val) => {
		if(val) {
			acc.push({ value: val.position, label: `${val.position + 1}: ${val.value}` })
		}
		return acc
	}, [])

	let localePortValue
	if(locales === 'de' && (terminalType === '8' || terminalType === '12')) {
		localePortValue = '20002'
	}else if(locales === 'de-ch' && terminalType === '8') {
		localePortValue = '4100'
	} else if((locales === 'de-ch' || locales === 'de') && terminalType === '9') {
		localePortValue = '5577'
	}

	useEffect(() => formApi.setValue('parameters.paymentTerminal.port', localePortValue), [localePortValue])
	return(
		<ExpandableBlocks nested>
			<ContentBlock label={t('options_section.strings.eft_terminal')}>
				<Col type='row'>
					<Select
						field='parameters.paymentTerminal.id'
						label={t('options_section.strings.terminal')}
						remoteOptions={{
							query: loadAppConstants,
							variables: { type: 82, language: i18n.language }
						}}
					/>
				</Col>
				<Divider/>
				{(terminalType === '10') &&
				<Row>
					<Col type='row' xs>
						<Text field='parameters.paymentTerminal.walleeApplicationKey' label={t('options_section.fields.wallee_application_key')} />
						<Text field='parameters.paymentTerminal.walleeVirtualTerminalId' label={t('options_section.fields.wallee_virtual_terminal_id')} />
						<Text field='parameters.paymentTerminal.walleeUserId' label={t('options_section.fields.wallee_user_id')} />
					</Col>
					<Col type='row' xs>
						<Text field='parameters.paymentTerminal.walleeSpaceId' label={t('options_section.fields.wallee_space_id')} />
						<Text field='parameters.paymentTerminal.walleeTerminalID' label={t('options_section.fields.wallee_terminal_id')} />
					</Col>
				</Row>
				}
				{(terminalType === '7') &&
					<Col type='row'>
						<Text field='parameters.paymentTerminal.sumUpEmail' label={t('options_section.fields.created_email')} />
						<Text field='parameters.paymentTerminal.sumUpPassword' label={t('options_section.fields.password')} type='password' pwdVisibilityBtn disablePasswordAutoComplete/>
					</Col>
				}
				{(terminalType === '8' || terminalType === '9' || terminalType === '12') &&
					<Col type='row'>
						<Text field='parameters.paymentTerminal.ip' label='TCP/IP' keepState />
						<Text field='parameters.paymentTerminal.port' label={t('options_section.fields.port')} keepState />
					</Col>
				}
				{terminalType !== '11' &&
					<>
						<Col type='row' style={{ display: displayDefaultFields ? 'block' : 'none' }}>
							<Text field='parameters.paymentTerminal.serialNumber' label='TID'/>
							<Text field='parameters.paymentTerminal.posId' label='POS ID'/>
						</Col>
						<Divider />
						<Col type='row'>
							<Checkbox field='parameters.printer.isPrintEFTReceipts' label={t('options_section.fields.auto_print_receipt_eft')} />
						</Col>
					</>
				}
				<Divider visible inverted />
				<Select
					field='parameters.paymentTerminal.creditPositionInfo.position'
					label={t('options_section.fields.link_credit_card')}
					options={selectOptions}
				/>
			</ContentBlock>
			<ContentBlock label={t('options_section.strings.glory_terminal')}>
				<Row>
					<Col xs>
						<Text field='parameters.gloryTerminalAddress' label={t('options_section.strings.localIPAdress')} />
						<Checkbox field='parameters.gloryTerminalConnected' label={t('common.fields.isActive')} />
					</Col>
					<Col xs>
						<Text field='parameters.gloryTerminalUser' label={t('common.fields.user')} />
						<Text field='parameters.gloryTerminalPassword' label={t('options_section.fields.password')} type='password' disablePasswordAutoComplete/>
					</Col>
				</Row>
			</ContentBlock>
		</ExpandableBlocks>

	)
}

export default EftTerminal
